import React from "react";
import Footer from "../Fotter";

function CancelAndReturn() {
  return (
    <div>
      <div className="sm:px-28 sm:py-10 px-10 py-0">
        <h1 className="text-3xl font-bold text-center mb-6">
          Cancellation and Return Policy
        </h1>

        <section className="mb-6">
          <h2 className="text-2xl font-semibold">General</h2>
          <ul className="list-disc">
            <li className="text-gray-700 mt-2">
              fliptwirls, having its registered address at Shop No. 4, 105 Jai
              Bajrang Nagar Keladevi Road, Happy Tower In Front of King George
              School Dewas, Dewas Madhya Pradesh, 455001, operates the website{" "}
              <a
                href="https://www.fliptwirls.com"
                className="text-blue-600 underline"
              >
                www.fliptwirls.com
              </a>{" "}
            </li>
            <li className="text-gray-700 mt-2">
              We aim to provide the best customer experience to our Users
              beginning from placing an order to initiating a return. While
              transacting on the fliptwirls Platform, you can expect a hassle-free
              experience in returning the Product that you have ordered and can
              rely on us as your preferred shopping destination.
            </li>
            <li className="text-gray-700 mt-2">
              This cancellation, replacement, return and refund policy (“Policy”),
              together with the Terms sets out our procedures and policies in
              accepting Product cancellation, replacement, return and refund
              thereof.
            </li>
          </ul>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold">Applicability of Policy</h2>
          <ul className="list-disc">
            <li className="text-gray-700 mt-2">
              By agreeing to use the fliptwirls Platform and/or initiating a
              request for purchase of Product(s) on the fliptwirls Platform, you
              agree to be bound by the terms contained in this Policy without
              modification. If you do not agree to the terms contained in this
              Policy, you are advised not to transact on the fliptwirls Platform.
            </li>
            <li className="text-gray-700 mt-2">
              Please note that we may from time to time change the terms of the
              Policy that govern your cancellation, replacement, return and refund
              of an order for Products on the fliptwirls Platform. Every time you
              wish to use the fliptwirls Platform, please check the Policy to
              ensure you understand the terms and conditions that apply at that
              time.
            </li>
          </ul>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold">Cancellation of Products</h2>
          <ul className="list-disc">
            <li className="text-gray-700 mt-2">
              You can cancel orders for Products partially or fully prior to the
              shipment is “Out for Delivery”. Orders cannot be cancelled once the
              package is “Out for Delivery”. You can track your order under ‘My
              Order’ section of your account on Platform or via link send to your
              email id.
            </li>
            <li className="text-gray-700 mt-2">
              In case you change your mind in relation to a particular order of
              the Product(s), you may cancel the placed purchase order on Platform
              under “My Orders” section of your account.
            </li>
            <li className="text-gray-700 mt-2">
              On receipt of the cancellation request, we will attempt to cancel
              the order/shipments as long as it is not “Out for Delivery”. You
              will receive an email as soon as the cancellation is accepted and
              the amount paid towards the partial/full order will be refunded to
              you within 3-7 (three to seven) business days from the date of
              acceptance of cancellation request. The amount shall be refunded to
              you through the same mode of payment used by you for the purchase or
              via credit to your store credit account which can be used for
              subsequent purchases. All refunds, except for refund to store credit
              account, shall be subject to our discretion, applicable policies and
              charges of the User’s bank/ financial institution.
            </li>
            <li className="text-gray-700 mt-2">
              We reserve the right to cancel your bulk orders placed on the
              Platform. To avoid such cancellations and/or for bulk orders, please
              visit our Contact Us section or E-mail{" "}
              <a
                href="https://www.fliptwirls.com"
                className="text-blue-600 underline"
              >
                www.fliptwirls.com
              </a>{" "}
            </li>
          </ul>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold">
            Replacement or Exchange of Products
          </h2>
          <ul className="list-disc">
            <li className="text-gray-700 mt-2">
              You may initiate the request for replacement of the Product within 7
              days from the time the Product(s) is delivered to you (“Replacement
              Period”)
            </li>
            <li className="text-gray-700 mt-2">
              You shall keep the Products in its unused, original condition, along
              with the original invoice/ sale receipt, brand outer box, MRP tags
              attached, user manual, warranty cards, and original accessories in
              manufacturer packaging for a successful replacement pick-up. We
              would accept the request for replacement of such Product subject to
              the terms of this Policy.
            </li>
            <li className="text-gray-700 mt-2">
              If you have received any Product which is subject to replacement in
              terms of this Policy, we suggest you to immediately register a
              request in this regard on the fliptwirls Platform. We will in our
              sole discretion verify if: (a) the defects and damages in the
              Products or inaccuracy claimed in such Products are acceptable by
              us, or (b) such defects, damages or inaccuracy are due to our
              default, and will accordingly post verification, accept or reject
              the request for replacement. For such verification, we may request
              you to send us images of the damaged, defective or inaccurate
              Product received and/or allow our personnel to schedule a call or
              visit to assess the damage, defect in the Product. Alternatively you
              could also share the Brand DOA certificate for us to process
              replacement. Further to the assessment of the damage or the concern
              reported in the replacement request, we may in our sole discretion
              resolve the issue subject to the assessment report, in a manner as
              we may deem fit.
            </li>
            <li className="text-gray-700 mt-2">
              Your replacement will be processed only when the conditions as may
              be stipulated by us are fulfilled at the time of replacement of such
              Products, such as the Product to be replaced being provided to us in
              original condition along with the price tag intact including
              original packaging of the Product, the serial number/ bar code of
              the Product matches our records, if Product(s) bought as a combo
              then Product(s) sent for replacement to be as a complete combo, the
              brand outer packaging of the Product and all accessories therein
              shall be intact, no damage having occurred post-delivery of the
              Product while in your possession etc.
            </li>
            <li className="text-gray-700 mt-2">
              You agree that we will not replace any Product: (i) if you have
              placed the order for a wrong Product model, colour or incorrect
              Product, (ii) if the Product belongs to non-replacement Product
              category (iii) if you fail to request replacement/register a
              complaint in relation to a damaged, defective or inaccurate Product
              within the Replacement Period (iv) if products like Mobiles,
              tablets, laptops are found activated during investigation. Any
              damage to the Product caused by your improper use of the Product, or
              any modification or change to the Product by you the User or a third
              party or any depreciation in the value for other reasons will not be
              deem such Product a damaged, defective or inaccurate Product and
              will not be considered a quality problem. Any decision by us in this
              regard shall be final and binding.
            </li>
            <li className="text-gray-700 mt-2">
              You should raise a replacement request at (+91)8588819430 or{" "}
              <a
                href="https://www.fliptwirls.com"
                className="text-blue-600 underline"
              >
                www.fliptwirls.com
              </a>{" "}
              to get a Replacement Authorization code for any of the eligible
              reasons. Once we receive your replacement request, we may schedule
              an engineer call or visit to assess the issue reported. Basis the
              engineer’s technical report a resolution for replacement will be
              offered. If the replacement request is approved, we will acknowledge
              your request for return via an email containing Product details,
              pickup details and Replacement Authorization Code. Our
              reverse-logistics partner will get in touch with you after
              Replacement Authorisation code is created in order to collect the
              approved Product for replacement. Please ensure to collect the
              manifest copy from the logistic partner while handing over the
              Product. The manifest copy will be your reference to track the
              return order for replacement in transit and claim for any losses in
              transit. Once the returned Product has been received by us for
              replacement, replacement Product will be shipped to your address
              entered on the original order.
            </li>
            <li className="text-gray-700 mt-2">
              You can’t replace Insta. Delivery (less than 3 hours of delivery)
              Product purchased by you on the fliptwirls Platform at our physical
              stores/ boutiques provided you.
            </li>
          </ul>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold">Return</h2>
          <ul className="list-disc">
            <li className="text-gray-700 mt-2">
              You may initiate the request for return of the product within 7 days
              from date of delivery (Return Period) if: Product ordered is
              different from what was ordered basis the Product description
              provided on the fliptwirls Platform, to be reported to us within 24
              hours of delivery or before activation of products like Mobiles,
              Tablets, Laptops, whichever is earlier User will be given an option
              at our sole discretion to raise a return request, only when the
              Products are not available in stock with fliptwirls for replacement
              for below cases: Product was found defective or is not in working
              condition; to be reported to us within 24 hours of delivery or
              before activation of the products like Mobiles, Tablets, Laptops,
              whichever is earlier’. Product is received in physically damaged
              condition, to be reported to us within 24 hours of delivery or
              before activation of the products like Mobiles, Tablets, Laptops,
              whichever is earlier. Product or parts of the Product or accessory
              is missing, to be reported to us within 24 hours of delivery or
              before activation of the products like Mobiles, Tablets, Laptops,
              whichever is earlier. All our packages come with “Tamper Evident
              Void Seals”, click here for more information on our packaging.
              Please ensure that you do not accept packages where the seal is
              tampered. Acceptance of a tampered “Void Seal” or a damaged box will
              automatically disqualify you from any return claims for physically
              damaged/defective products, incorrect product, or missing
              accessories.
            </li>
            <li className="text-gray-700 mt-2">
              You shall keep the Products in its unused, original condition, along
              with the original invoice/ sale receipt, brand outer box, MRP tags
              attached, user manual, warranty cards, and original accessories in
              manufacturer packaging for a successful return pick-up. We would
              accept the request for return of such Product subject to the terms
              of this Policy.
            </li>
            <li className="text-gray-700 mt-2">
              If you have received any Product which is subject to return in terms
              of this Policy, we suggest you to immediately register a request in
              this regard on the fliptwirls Platform. We will in our sole
              discretion verify if: (a) the defects and damages in the Products or
              inaccuracy claimed in such Products are acceptable by us, or (b)
              such defects, damages or inaccuracy are due to our default, and will
              accordingly post verification, accept or reject the request for
              return. For such verification, we may request you to send us images
              of the damaged, defective or inaccurate Product received and/or
              allow our personnel to schedule a call or visit to assess the
              damage, defect in the Product. Alternatively you could also share
              the Brand DOA certificate for us to process return. Further to the
              assessment of the damage or the concern reported in the return
              request, we may in our sole discretion resolve the issue subject to
              the assessment report, in a manner as we may deem fit.
            </li>
            <li className="text-gray-700 mt-2">
              Your return will be processed only when the conditions as may be
              stipulated by us are fulfilled at the time of return of such
              Products, such as the Product being return in original condition
              along with the price tag intact including original packaging of the
              Product, and the serial number/ bar code of the Product matches our
              records, if Product(s) bought as a combo should be returned as the
              complete combo, the brand outer packaging of the Product and all
              accessories therein, no damage having occurred post-delivery of the
              Product while in your possession etc.
            </li>
            <li className="text-gray-700 mt-2">
              You agree that we will not accept the return of any Product: (i) if
              you have placed the order for a wrong Product model, colour or
              incorrect Product, (ii) if the Product belongs to non-returnable
              Product category (mentioned below) (iii) if you fail to
              return/register a complaint in relation to a damaged, defective or
              inaccurate Product within the Return Period. Any damage to the
              Product caused by your improper use of the Product, or any
              modification or change to the Product by you the User or a third
              party or any depreciation in the value for other reasons will not be
              deem such Product a damaged, defective or inaccurate Product and
              will not be considered a quality problem. Any decision by us in this
              regard shall be final and binding.
            </li>
            <li className="text-gray-700 mt-2">
              You should raise a return request at (+91)8588819430 or{" "}
              <a
                href="https://www.fliptwirls.com"
                className="text-blue-600 underline"
              >
                www.fliptwirls.com
              </a>{" "}
              to get a Return Authorization code for any of the eligible reasons.
              Once we receive your return request, we may schedule an engineer
              call or visit to assess the issue reported. Basis the engineer’s
              technical report a resolution for return will be offered. If the
              return request is approved, we will acknowledge your request for
              return via an email containing Product details, pickup details and
              Return Authorization Code. Our reverse-logistics partner will get in
              touch with you after Return Authorisation code is created in order
              to collect the approved Product for return. Please ensure to collect
              the manifest copy from the logistic partner while returning the
              Product. The manifest copy will be your reference to track the
              return order transit and claim for any losses in transit.
            </li>
            <li className="text-gray-700 mt-2">
              You may also return an Insta Delivery (less than 3 three hours
              delivery) Product purchased by you on the fliptwirls Platform at our
              physical stores as indicated on the invoice. You can call our store
              number listed on the invoice for any issues, queries and return
              request of Insta Delivery products. Your return will be processed
              once all return relevant conditions under this policy are fulfilled
              by you at the time of return of Insta Delivery Product(s). Once
              return is processed for the Insta Delivery, we will initiate the
              refund to your original mode of payment or store credit as per our
              discretion.
            </li>
            <li className="text-gray-700 mt-2">
              You should make sure to erase any/all personal information from an
              electronic device that stores any personal information, prior to
              returning to us. fliptwirls shall not be liable for any misuse or
              usage of such information.
            </li>
          </ul>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold">Refund</h2>
          <ul className="list-disc">
            <li className="text-gray-700 mt-2">
              At the time of raising a request for return or cancelling the
              Products on the fliptwirls Platform, you may seek refund. Such
              refund will be made to you only in the event the payment has been
              received by us for the Product.
            </li>
            <li className="text-gray-700 mt-2">
              Please be informed that when you opt to cancel or return the
              Products, upon our verification and assessment of the Products and
              the documents relating thereto, the refund amount for such Products
              which are eligible for return as per the terms of this Policy, will
              be processed within 48 (forty eight) hours from the date of us
              receiving the returned Product back at our warehouse. Your refund
              will be processed only when the conditions as may be stipulated by
              us are fulfilled, such as the Product being returned in original
              condition, along with the price tag intact including original
              packaging of the Product, the brand outer packaging of the damage or
              defective or inaccurate Product and all accessories therein is
              intact. For the sake of abundant clarity, it is clarified that we
              shall not make any refund in respect of a Product that is deemed
              ineligible for a refund based on our verification and assessment.
              The refund amount will be credited to the original payment mode
              opted by you or given as Store credit to you. You acknowledge that
              after initiation of refund, it may take additional time for your
              refund to reflect in your account which is subject to your financial
              institution or payment solution provider terms and conditions.
            </li>
            <li className="text-gray-700 mt-2">
              We do not make any cash refunds. The amount will be refunded to you
              within 7 (seven) working days into the original the mode of payment
              chosen by you. Sometimes banks or financial intermediaries take a
              longer time to process the refund request. However, if the refund
              does not happen by the date advised, you may contact us, and we will
              gladly help you.
            </li>
            <li className="text-gray-700 mt-2">
              Refund to be made to the User shall not include any amount paid
              towards shipping charges or any other such charges applicable from
              time to time. However, in the event a Product has been delivered
              with a defect or damage (for reasons attributable to, and accepted
              by us after due verification at its sole discretion) we may refund
              the shipping charges to you. You will be provided with a refund if
              you have received a non-returnable Product in a damaged or defective
              condition subject to verification and examination of the damage or
              defect of the Product by us.
            </li>
            <li className="text-gray-700 mt-2">
              We provide refund for few scenarios such as Product for replacement
              is not available with us or for Products that were incorrectly
              represented on the website. We reserve the right to reject a refund
              request for a Product if it does not satisfy the quality conditions
              specified under this Policy on our assessment pursuant to its
              return. We may in such cases notify you and send the returned
              Product back without initiating a refund.
            </li>
          </ul>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold">Additional Note</h2>
          <p className="text-gray-700 mt-2">
            For installable products, returns will be accepted only if the product
            was installed by ResQ engineers Returns will not be accepted if any of
            the installable products is unboxed and/or installed by customer
            himself or by anyone other than fliptwirls service team resQ or
            engineers authorised by resQ. Any damages or defects for such products
            will not be accepted. These could include but not limited to –
          </p>
          <ol className="list-decimal">
            <li className="text-gray-700 mt-2"> GAS Leakages in Air Conditioners</li>
            <li className="text-gray-700 mt-2"> Wrong connections or Wrong installations</li>
            <li className="text-gray-700 mt-2">Missing items reported, damages, dents etc.</li>
            <li className="text-gray-700 mt-2">On account of any physical damages</li>

          </ol>
        </section>

        <section className="mt-8">
          <h2 className="text-xl font-semibold mb-4">Customer Support</h2>
          <p><strong>Address:</strong> Thakur Ji Ki Haweli Jalpa Mata Mandir Ke Pass Rajgarh, Rajgarh Madhya Pradesh, Bharat Pin 465661</p>
          <p><strong>Phone:</strong> (+91)8588819430</p>
          <p><strong>E-mail:</strong> info@fliptwirls.com</p>
          <p><strong>Website:</strong> <a href="http://www.fliptwirls.com" className="text-blue-500 underline">www.fliptwirls.com</a></p>
        </section>
      </div>
      <Footer />
    </div>
  );
}

export default CancelAndReturn;
